var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('iframe',{ref:"iframe",attrs:{"src":"https://wed.ruiziyou.com/film-v9.html","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }